import React from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { CreditCardForm } from './CreditCardForm/CreditCardForm';
import * as dataService from './dataService';



const stripePromise = loadStripe(process.env['REACT_APP_STRIPE_PUBLIC_KEY'] ?? '');

export const EditPaymentSection: React.FC = () => {
  const editPaymentSectionQueryTuple = dataService.useEditPaymentSectionQuery();
  const [
    fnWrappedUpdatePaymentInfoMutation,
    updatePaymentInfoMutationTuple
  ] = dataService.useUpdatePaymentInfoMutation();



  return (
    <Elements stripe={stripePromise}>
      <CreditCardForm
        defaultValues={editPaymentSectionQueryTuple.data}
        onUpdate={fnWrappedUpdatePaymentInfoMutation}
        loading={editPaymentSectionQueryTuple.loading || updatePaymentInfoMutationTuple.loading}
      />
    </Elements>
  );
};
